import { VcsIntegrationTestType } from "types/generated";
import { Link, ArrowUpDown, LockUnlocked, Webhook } from "components/icons/generated";

export const VCS_CHECK_TYPE_LABELS = {
  [VcsIntegrationTestType.Connection]: "Connection",
  [VcsIntegrationTestType.Permissions]: "Permissions",
  [VcsIntegrationTestType.GithubAppEvents]: "App events",
  [VcsIntegrationTestType.Webhook]: "Webhook",
};

export const VCS_CHECK_TYPE_ICONS = {
  [VcsIntegrationTestType.Connection]: Link,
  [VcsIntegrationTestType.Permissions]: LockUnlocked,
  [VcsIntegrationTestType.GithubAppEvents]: ArrowUpDown,
  [VcsIntegrationTestType.Webhook]: Webhook,
};
